export default class Locale_ThemeDesigner { 
	UseAdvancedSettings: string = "Use advanced setting";
	GoTo: string = "Go to";
	AdvancedEditDoesNotMakeSemanticColors: string = "When using advanced edit, semantic colors are not automatically generated!";
	Customizations: string = "Customizations (coming soon)";
	TopbarTheme: string = "Topbar theme";
	TopbarCustomizations: string = "Topbar customizations (coming soon)";
}